import { AuthGuard, CrudOp, projectOverviewAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const ProjectOverviewView: FC = () => (
  <AuthGuard authScope={projectOverviewAuthScope} crudOp={CrudOp.READ}>
    <Suspense><LazyProjectOverviewView/></Suspense>
  </AuthGuard>
);

const LazyProjectOverviewView = lazy(importView(
  () => import("../components/ProjectOverviewView"),
  (it) => it.ProjectOverviewView,
));
